import React from 'react';
import classNames from 'classnames';

import styles from './Button.module.scss';

export enum ButtonVariant {
  Primary = 'Primary',
  Alternative = 'Alternative',
  AlternativeBordered = 'AlternativeBordered',
}

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  centered?: boolean;
}

const stylesByType = {
  [ButtonVariant.Primary]: styles.button_primary,
  [ButtonVariant.Alternative]: styles.button_alternative,
  [ButtonVariant.AlternativeBordered]: styles.button_alternative_bordered,
};

const Button = (props: React.PropsWithChildren<ButtonProps>) => {
  const { children, centered, className, type = 'button', variant = ButtonVariant.Primary, ...restProps } = props;
  const buttonStyle = classNames(stylesByType[variant], className, {
    [styles.centered]: centered,
  });

  return (
    // eslint-disable-next-line react/button-has-type
    <button {...restProps} className={buttonStyle} type={type}>
      {children}
    </button>
  );
};

export default Button;
